var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockPeriod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.234 1.74A12.27 12.27 0 0 1 16.554.669L16 .298l-.555.37A12.27 12.27 0 0 1 3.767 1.741L2 .983v14.364a16.242 16.242 0 0 0 13.848 16.141l.152.024.152-.024A16.242 16.242 0 0 0 30 15.348V.982ZM16 25.5a10 10 0 1 1 10-10.023A10.023 10.023 0 0 1 16 25.5Z",
    fill: "#9d8f8f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.934 14.5a7.917 7.917 0 0 0-1.619-3.901l-1.365 1.365-1.414-1.414L20.9 9.186A7.963 7.963 0 0 0 17 7.569V9.5h-2V7.57a7.963 7.963 0 0 0-3.9 1.616l1.364 1.364-1.414 1.414L9.685 10.6A7.917 7.917 0 0 0 8.066 14.5H10v2H8.072a7.987 7.987 0 0 0 1.62 3.894l1.358-1.358 1.414 1.414-1.359 1.359A7.94 7.94 0 0 0 15 23.43V21.5h2v1.93a7.94 7.94 0 0 0 3.895-1.621l-1.36-1.359 1.415-1.414 1.358 1.358a7.987 7.987 0 0 0 1.62-3.894H22v-2ZM20 16.5h-5v-5h2v3h3Z",
    fill: "#9d8f8f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPeriod);
export default __webpack_public_path__ + "static/media/lockPeriod.3b888435bda12fd3e6bb96f0bffb8440.svg";
export { ForwardRef as ReactComponent };